import React, { Fragment } from 'react'
import Link from 'gatsby-link'

import HeaderSpacer from '../global/header-spacer'
import SearchInput from './searchInput'

import GlobalPropsProvider from '../utils/stateProvider'

import globalState from '../../helpers/globalState'
import { translate } from '../../helpers/stringTranslation'
import buildLink from '../../helpers/linkBuilder'

import {
  accentColor,
  h2r,
  r2h,
  interpolateHSL,
  rgb2hsl,
} from '../../helpers/colors'

import Styles from '../../styles/components/menu.module.scss'
const {
  container,
  menuHidden,
  menuHover,
  inner,
  menuOpen,
  backgroundLeft,
  backgroundRight,
  menuList,
  menuItem,
  menuLink,
  menuItemWrapper,
} = Styles

const accentColorRGB = rgb2hsl(h2r(accentColor))
const blackColorRGB = [0.9221183800623053, 0, 0]

class MenuItemArrow extends React.PureComponent {
  render() {
    const { className, open, onClick } = this.props

    const classNames = [
      open ? Styles.submenuArrowExpanded : Styles.submenuArrow,
    ]

    if (className) {
      classNames.push(className)
    }

    return (
      <span
        onClick={() => {
          if (onClick) {
            onClick()
          }
        }}
        className={classNames.join(' ')}
        title={open ? 'Schowaj podmenu' : 'Rozwiń podmenu'}
      >
        <span className={Styles.submenuArrowExpand} />
        <span className={Styles.submenuArrowCollapse} />
      </span>
    )
  }
}

class MenuItem extends React.Component {
  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
    this.state = {
      open: false,
    }
  }

  onClick() {
    this.setState(state => ({ ...state, open: !state.open }))
  }
  render() {
    const { to, label, submenu } = this.props
    const { open } = this.state

    return (
      <li className={menuItem} key={label}>
        <div className={menuItemWrapper}>
          <Link className={menuLink} to={to}>
            {label}
          </Link>
          {submenu && (
            <MenuItemArrow
              onClick={this.onClick}
              className={Styles.itemSubmenuArrow}
              open={open}
            />
          )}
        </div>
        {submenu && (
          <Fragment>
            <div
              className={open ? Styles.itemSubmenu : Styles.itemSubmenuHidden}
            >
              {submenu.map((item, index) => (
                <Link
                  key={index}
                  className={
                    open ? Styles.itemSubmenuItem : Styles.itemSubmenuItemHidden
                  }
                  to={item.to}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </Fragment>
        )}
      </li>
    )
  }
}

class Menu extends React.Component {
  constructor(props) {
    super(props)

    this.lastScrollTop = null
    this.lastScrollBody = false

    this.state = {
      backgroundProgress: 0,
      inMenuScrolled: 0,
    }

    this.setRef = this.setRef.bind(this)
    this.onMenuScroll = this.onMenuScroll.bind(this)

    this.handleMouseMove = this.handleMouseMove.bind(this)

    //this.buildRoutes(props.language)
    this.ref = null
  }
  /*
  buildRoutes(lang) {
    this.routes = [
      {
        to: buildLink({
          slug: 'portfolio',
          type: 'static',
          lang,
        }),
        label: translate('portfolio'),
      },
      {
        to: buildLink({
          slug: 'post',
          type: 'static',
          lang,
        }),
        label: translate('articles'),
      },
      {
        to: buildLink({
          slug: 'offer',
          type: 'static',
          lang,
        }),
        label: translate('offer'),
        submenu: [
          {
            to: buildLink({
              slug: 'analisys',
              type: 'static',
              lang,
            }),
            label: translate('analisys'),
          },
          {
            to: buildLink({
              slug: 'strategy',
              type: 'static',
              lang,
            }),
            label: translate('strategy'),
          },
          {
            to: buildLink({
              slug: 'identification',
              type: 'static',
              lang,
            }),
            label: translate('identification'),
          },
        ],
      },
      {
        to: buildLink({
          slug: lang === 'en' ? 'team' : 'zespol',
          type: 'page',
          lang,
        }),
        label: translate('aboutus'),
      },
      {
        to: buildLink({
          slug: lang === 'en' ? 'contact' : 'kontakt',
          type: 'page',
          lang,
        }),
        label: translate('contact'),
      },
    ]
  }
*/
  componentWillReceiveProps(nextProps) {
    if (this.props.open !== nextProps.open) {
      if (nextProps.open) {
        if (document.documentElement.scrollTop !== 0) {
          this.lastScrollTop = document.documentElement.scrollTop
          this.lastScrollBody = false
        } else {
          this.lastScrollTop = document.body.scrollTop
          this.lastScrollBody = true
        }

        document.body.style.top = `-${this.lastScrollTop}px`

        document.body.classList.toggle('menu-open', true)
      } else {
        document.body.classList.toggle('menu-open', false)

        if (this.lastScrollBody) {
          document.body.scrollTop = this.lastScrollTop
        } else {
          document.documentElement.scrollTop = this.lastScrollTop
        }

        this.lastScrollTop = null
      }
    }

    // if (this.props.language !== nextProps.language) {
    //   this.buildRoutes(nextProps.language)
    // }
  }

  handleMouseMove(e) {
    const progress = e.clientY / window.innerHeight
    this.setState(state => ({
      ...this.state,
      backgroundProgress: progress,
      backgroundColor: r2h(
        interpolateHSL(accentColorRGB, blackColorRGB, progress)
      ),
    }))
  }

  onMenuScroll() {
    const inMenuScrolled = this.ref.scrollTop > 30
    if (inMenuScrolled !== globalState.state.inMenuScrolled) {
      globalState.setState({ inMenuScrolled })
    }
  }
  setRef(ref) {
    if (this.ref !== ref && this.ref) {
      this.ref.removeEventListener('scroll', this.onMenuScroll)
    }

    this.ref = ref

    if (ref) {
      ref.addEventListener('scroll', this.onMenuScroll)
    }
  }

  render() {
    const {
      open,
      hover,
      translations,
      language,
      routes,
      languages,
    } = this.props
    const { inMenuScrolled } = this.state

    const backgroundStyle = {
      backgroundColor: this.state.backgroundColor,
    }

    return (
      <div
        ref={this.setRef}
        onMouseMove={this.handleMouseMove}
        className={open ? menuOpen : hover ? menuHover : menuHidden}
      >
        <div className={backgroundLeft} style={backgroundStyle} />
        <div className={backgroundRight} style={backgroundStyle} />
        <HeaderSpacer />
        <div className={inner}>
          <div className={container}>
            <nav>
              <ul className={menuList}>
                {routes.map((props, index) => (
                  <MenuItem key={index} {...props} />
                ))}
              </ul>
            </nav>
            {languages.length > 0 && (
              <div className={Styles.languages}>
                {languages.map(lang => {
                  if (lang in translations) {
                    return (
                      <Link
                        key={lang}
                        to={translations[lang]}
                        className={Styles.languageItem}
                      >
                        {lang}
                      </Link>
                    )
                  } else if (lang !== language) {
                    return (
                      <Link
                        key={lang}
                        to={buildLink({
                          lang: lang,
                          slug: '',
                          type: 'page',
                        })}
                        className={Styles.languageItem}
                      >
                        {lang}
                      </Link>
                    )
                  }
                  return (
                    <div key={lang} className={Styles.languageItem}>
                      {lang}
                    </div>
                  )
                })}
              </div>
            )}
            <SearchInput open={open} />
          </div>
        </div>
      </div>
    )
  }
}

export default GlobalPropsProvider(Menu, state => ({
  translations: state.translations,
  language: state.language,
  languages: state.languages,
  routes: state.menu[state.language],
}))



// WEBPACK FOOTER //
// ./src/components/menu/menu.js